/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
import { Box, Modal } from "@mui/material";
import { converterObjetoParaString } from "hooks/convertObjectToString";
import { useBuscarLeadInterface } from "interfaces";
import * as React from "react";
import { useEffect } from "react";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { RootStateOrAny, useSelector } from "react-redux";
import FormNovoAtendimento from "screens/plantao/components/completedCalls/components/FormNovoAtendimento";
import { useBuscarLead } from "services/api";

import icons from "../../../../../../constants/icons";
import useFormattedPhoneHide from "../../../../../../hooks/useFormattedPhoneHide";
import { useMaskedEmail } from "../../../../../../hooks/useMaskedEmail";
import { useListarAtendimentos } from "../../../../../../services/api/AppWeb_Atendimento";
import { AuthState } from "../../../../../../store/ducks/auth/types";
import {
  VisitaAgendadaModal,
  VisitaAgendadaStatesInterface,
} from "./modals/visitaAgendadaModal";
import * as Styles from "./styles";

// ---------------------------------------------------
// Tipos e interfaces
// ---------------------------------------------------
interface AnyObject {
  [key: string]: any;
}

interface CorretorProps {
  label: string;
  value: string;
}

interface DataLeadProps {
  nomeLead: string;
  telefoneLead: string;
  emailLead: string;
  visitaEmAberto: boolean;
  idTarefaLead: string;
  idLeadCorretor: string;
}

interface DataBuscarLeadProps {
  data: DataLeadProps[];
  pagination: any;
}

interface Props {
  isOpen: boolean;
  onClose: any;
  paramsBuscarLead: useBuscarLeadInterface;
  visitaAgendadaStates: VisitaAgendadaStatesInterface;
  corretor: CorretorProps | null;
  onCloseMain: () => void;
}

interface DropdownBoxContentInterface {
  openModal: () => void;
  nomeLead: string | undefined;
  dataBuscarLead: DataBuscarLeadProps;
  isSuccess: boolean;
  onDataSelected: (item: any) => void;
  idCorretor: string | null | undefined;
  onCloseMain: () => void;
}

// ---------------------------------------------------
// Componente principal: DropdownBox
// ---------------------------------------------------
export default function DropdownBox(props: Props) {
  const [modalAgendadaIsOpen, setModalAgendadaIsOpen] =
    React.useState<boolean>(false);

  const {
    data: dataBuscarLead,
    status: statusBuscarLead,
    refetch: refetchBuscarLead,
    isSuccess: isSuccessBuscarLead,
  } = useBuscarLead({
    queryKey: "buscar_lead_head",
    params: converterObjetoParaString(props.paramsBuscarLead),
  });

  const [leadSelected, setSelectedLead] = React.useState(null);

  React.useEffect(() => {
    if (props.isOpen) {
      refetchBuscarLead();
    }
  }, [props.isOpen]);

  return (
    <div>
      <Modal
        open={props.isOpen}
        onClose={props.onClose}
        sx={{ "& .MuiBackdrop-root": { backgroundColor: "transparent" } }}
      >
        <Box sx={{ ...Styles.Modalstyle }}>
          {statusBuscarLead === "loading" && (
            <Styles.TextStatus>
              <p>Procurando cliente...</p>
            </Styles.TextStatus>
          )}
          {statusBuscarLead === "error" && (
            <Styles.TextStatus>
              <p>Erro ao procurar cliente, tente novamente</p>
            </Styles.TextStatus>
          )}
          {statusBuscarLead === "success" && (
            <>
              {dataBuscarLead?.data?.length > 0 ? (
                <DropdownBoxContent
                  nomeLead={props?.paramsBuscarLead?.NomeLead}
                  openModal={() => setModalAgendadaIsOpen(true)}
                  dataBuscarLead={dataBuscarLead}
                  onDataSelected={(item) => setSelectedLead(item)}
                  isSuccess={isSuccessBuscarLead}
                  idCorretor={props?.paramsBuscarLead?.idLeadCorretor}
                  onCloseMain={() => props.onClose()}
                />
              ) : (
                <Styles.TextStatus>
                  <p>Nenhum cliente</p>
                </Styles.TextStatus>
              )}
            </>
          )}

          <VisitaAgendadaModal
            visitaAgendadaStates={props.visitaAgendadaStates}
            corretor={props.corretor}
            isOpen={modalAgendadaIsOpen}
            closeModal={() => setModalAgendadaIsOpen(false)}
            data={leadSelected || null}
          />
        </Box>
      </Modal>
    </div>
  );
}

// ---------------------------------------------------
// Subcomponente: DropdownBoxContent
// ---------------------------------------------------
function DropdownBoxContent(props: DropdownBoxContentInterface) {
  const [openNewCall, setOpenNewCall] = React.useState(false);
  const { plantaoVendas, supervisorProduto } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();

  const [filtros, setFiltros] = React.useState<any>(null);

  const { refetch: refetchAtendimentos } = useListarAtendimentos({
    queryKey: "antendimentos",
    idLocalVendas: supervisorProduto ? pdvSelected?.value : plantaoVendas?.id,
    params:
      filtros === null
        ? converterObjetoParaString({ PaginaAtual: 1, TotalItensRetorno: 25 })
        : converterObjetoParaString(filtros),
  });

  useEffect(() => {
    getFilter();
  }, []);

  // Converte objetos que têm { value: "algumValor" } para strings simples
  function transformObject(obj: AnyObject): AnyObject {
    const transformedObj: AnyObject = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fieldValue = obj[key];
        if (
          fieldValue &&
          typeof fieldValue === "object" &&
          "value" in fieldValue
        ) {
          transformedObj[key] = fieldValue.value;
        } else {
          transformedObj[key] = fieldValue;
        }
      }
    }
    return transformedObj;
  }

  const getFilter = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    const filtros2Json = JSON.parse(filtross);
    if (filtros2Json) {
      filtros2Json.PaginaAtual = 1;
      filtros2Json.TotalItensRetorno = 25;
      setFiltros(transformObject(filtros2Json));
    }
  };

  const onHandleClick = (item: DataLeadProps) => {
    props.openModal();
    props.onDataSelected(item);
  };

  return (
    <Styles.BoxHeader length={props?.dataBuscarLead?.data?.length ?? 0}>
      {props?.isSuccess && props?.dataBuscarLead?.data?.length === 0 && (
        <Styles.TextStatus>
          <p>Nenhum Lead</p>
        </Styles.TextStatus>
      )}

      <Styles.List>
        {props?.dataBuscarLead?.data?.map((item: DataLeadProps, index) => (
          <React.Fragment key={index}>
            <LeadItem
              item={item}
              onHandleClick={onHandleClick}
              setOpenNewCall={setOpenNewCall}
            />
          </React.Fragment>
        ))}
      </Styles.List>

      <Modal open={openNewCall} onClose={() => setOpenNewCall(false)}>
        <FormNovoAtendimento
          refresh={() => {
            refetchAtendimentos();
            props.onCloseMain();
          }}
          allFields={false}
          nomeLead={props?.dataBuscarLead?.data[0]?.nomeLead}
          closeModal={() => setOpenNewCall(false)}
          idCorretor={props?.dataBuscarLead?.data[0]?.idLeadCorretor}
        />
      </Modal>
    </Styles.BoxHeader>
  );
}

// ---------------------------------------------------
// Subcomponente: LeadItem
// (Aqui ficam as chamadas aos hooks para cada Lead)
// ---------------------------------------------------
function LeadItem({
  item,
  onHandleClick,
  setOpenNewCall,
}: {
  item: DataLeadProps;
  onHandleClick: (item: DataLeadProps) => void;
  setOpenNewCall: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const formattedPhone = useFormattedPhoneHide(item?.telefoneLead);
  const maskedEmail = useMaskedEmail(item?.emailLead);

  return (
    <>
      <Styles.FlexBox>
        <p className="name">{item?.nomeLead || "Nome"}</p>
        <Styles.Td>
          <i
            style={{
              backgroundColor: "#4CAF50",
              borderRadius: 30,
              color: "white",
              padding: 2,
              marginRight: 10,
            }}
            className="lab la-whatsapp la-1x"
          />
          <p className="information">{formattedPhone}</p>
        </Styles.Td>
        <Styles.Td>
          <img
            width={20}
            style={{ marginRight: 10 }}
            src={icons?.outlookIcon}
            alt="icone outlook"
          />
          <p className="information">{maskedEmail}</p>
        </Styles.Td>
      </Styles.FlexBox>

      {item?.visitaEmAberto ? (
        <Styles.Button onClick={() => onHandleClick(item)}>
          <p>Visita agendada</p>
        </Styles.Button>
      ) : (
        <Styles.Button onClick={() => setOpenNewCall(true)}>
          <p>Cadastrar visita</p>
        </Styles.Button>
      )}
    </>
  );
}
